import React from 'react';
import {Link, useLocation} from 'react-router-dom';

export type ImpactedProperty = {featureId: string; featureName: string};

const dedupeProperties = (properties: ImpactedProperty[]): ImpactedProperty[] => {
  const seen = new Set<string>();
  return properties.filter((p) => {
    if (seen.has(p.featureId)) return false;
    seen.add(p.featureId);
    return true;
  });
};

export const ImpactedPropertyLinks: React.FunctionComponent<{properties: ImpactedProperty[]}> = ({
  properties,
}) => {
  const {pathname: currentUrlPath} = useLocation();

  const makeFeatureUrlFromCurrentPath = (featureId: string) => {
    const orgSlug = currentUrlPath.split('/')[1];
    const projectSlug = currentUrlPath.split('/')[4];
    return `/${orgSlug}/projects/${projectSlug}/map/${featureId}`;
  };

  return (
    <>
      {dedupeProperties(properties).map((property, idx) => (
        <React.Fragment key={property.featureId}>
          {idx > 0 && ', '}
          <Link
            to={makeFeatureUrlFromCurrentPath(property.featureId)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {property.featureName}
          </Link>
        </React.Fragment>
      ))}
    </>
  );
};
